import React from 'react';
import cn from 'classnames';
import { AnchorLogo } from 'seagull/icons';
import { isMobileDevice } from "../../../infra/device";
import styles from "./UnauthorizedPageContainer.module.scss";
export default function UnauthorizedPageContainer(props) {
  const {
    testId,
    wideLayout,
    children,
    animatedBackground = true,
    hideBanner = false
  } = props;
  const mp4Name = isMobileDevice ? 'Anchor_Mobile_Asset.mp4' : 'Anchor_Header.mp4';
  const posterName = isMobileDevice ? '619225327129c80f56875d9f_Anchor_Mobile_Asset.jpg' : '6192253394e4106ddbeb5bdc_Anchor_Web_Asset.jpg';
  return /*#__PURE__*/React.createElement("div", {
    className: styles.unauthorizedPageContainer,
    "data-testid": testId
  }, animatedBackground && /*#__PURE__*/React.createElement("video", {
    className: styles.video,
    loop: true,
    muted: true,
    autoPlay: true,
    playsInline: true,
    width: "100%",
    src: "https://mtcdn.co/Anchor/".concat(mp4Name),
    poster: "https://assets.website-files.com/618126a3584667ecd40daf91/".concat(posterName),
    "data-testid": "unauthorized-page-background-animation"
  }), !hideBanner ? /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(AnchorLogo, {
    className: styles.logo
  }), /*#__PURE__*/React.createElement("div", {
    "data-testid": "unauthorized-page-title",
    className: styles.title
  }, "Do Business. Not Billing."), /*#__PURE__*/React.createElement("div", {
    "data-testid": "unauthorized-page-subtitle",
    className: styles.subTitle
  }, "Get ready to get paid on time, every time. Automatically.")) : /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
    className: styles.formWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.formCard, wideLayout && styles.wide)
  }, children)), /*#__PURE__*/React.createElement("footer", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement("a", {
    className: styles.link,
    href: "https://www.sayanchor.com/privacy-policy"
  }, "Privacy Policy"), /*#__PURE__*/React.createElement("a", {
    className: styles.link,
    href: "https://www.sayanchor.com/terms-of-contact"
  }, "Terms of Service"), /*#__PURE__*/React.createElement("a", {
    className: styles.link,
    href: "https://www.sayanchor.com/data-privacy"
  }, "Data Privacy")));
}